<div class="required-documents-item-header clearfix" (click)="!mustShowAviso ? !document.somenteDownload && fileInput.click() : showAvisoDocumentacao()">
  <div class="required-documents-item-image-wrapper col-xs-2">
    <div class="required-documents-item-check" *ngIf="hasFile || wasUploaded">
      <em class="required-documents-item-check-icon glyphicon glyphicon-ok"></em>

      <span class="required-documents-item-check-badge"></span>
    </div>
  </div>

  <div class="required-documents-item-name col-xs-8">
    {{ document.descPendencia || document.descDocto }}
  </div>

  <div class="required-documents-item-icon-wrapper col-xs-2">
    <em class="required-documents-item-icon-upload" *ngIf="!document.somenteDownload && hasUploadDefined && !hasFile"></em>
    <a target="_blank" *ngIf="document.url" (click)="$event.stopPropagation();print(document)" title="Imprimir arquivo">
      <em class="required-documents-item-icon-printer"></em>
    </a>
    <em class="required-documents-item-icon" *ngIf="!hasUploadDefined"></em>
  </div>
</div>

<div class="required-documents-item-body" *ngIf="hasFile || wasUploaded">
  <ul class="selected-files">
    <li class="selected-files-item pb-3" *ngFor="let file of uploadedFiles">
      <div class="col-xs-3"></div>
      <div class="col-xs-6 selected-files-item-name">
        <button class="selected-files-remove-button align-top" style="padding-right: 5px;" aria-label="Já carregado" (click)="show(file)">
          <em class="glyphicon glyphicon-ok"></em>
        </button>
        <span class="cursor-pointer" (click)="show(file)">
          {{ file.name }}
        </span>
      </div>
      <div class="col-xs-3 text-right">
        <button class="selected-files-remove-button align-top" aria-label="Visualizar" (click)="show(file)">
          <img src="../../../../assets/icones/ic_visualizar_imagem.svg" class="glyphicon align-top" alt="Ícone de visualização"/>
        </button>
      </div>
    </li>

    <li class="selected-files-item" *ngFor="let file of filesToUpload; index as fi">
      <div class="col-xs-3"></div>
      <div class="col-xs-5 selected-files-item-name">{{ file.name }}</div>

      <div class="col-xs-3 text-right">
        <button class="selected-files-remove-button align-top" aria-label="Visualizar" (click)="show(file)">
          <img src="../../../../assets/icones/ic_visualizar_imagem.svg" class="glyphicon align-top" alt="Ícone de visualização" />
        </button>
        <button class="selected-files-remove-button align-top" style="padding-left: 5px;" aria-label="Remover" (click)="removeFileCallback.emit(fi)">
          <em class="glyphicon glyphicon-trash"></em>
        </button>
      </div>
    </li>
  </ul>

  <div class="text-center pb-5">
    <button
      type="button"
      class="selected-files-remove-all-button btn btn-xs "
      *ngIf="filesToUpload.length > 1"
      (click)="removeAllFilesCallback.emit({})"
  >
    <span class="selected-files-remove-all-icon glyphicon glyphicon-trash"></span>
    Remover todos
  </button>
</div>
  </div>


<span class="hidden">
  <input
    #fileInput
    type="file"
    multiple
    (change)="fileChange.emit($event)"
    [accept]="acceptFiles"
  />
</span>
